// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CompanyAuth-page-GUyaI {
  --red: #e8232b;
  --red-d: #c2151c;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  --bg: #f7f8f9;
  --green: #16a34a;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
  background: #fff;
}

.CompanyAuth-wrap-UateC,
.CompanyAuth-authWrap-VeVZx {
  max-width: 1080px;
  margin: 0 auto;
  padding: 0 24px;
}

/* HERO */

.CompanyAuth-hero-PChKe {
  background: radial-gradient(circle at 85% 12%, #fff0ef, transparent 45%),
    radial-gradient(circle at 8% 95%, #fff0ef, transparent 45%), #fff;
  padding: 64px 0 44px;
  text-align: center;
}

.CompanyAuth-eyebrow-O7b7Q {
  display: inline-block;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--red);
  margin-bottom: 14px;
}

.CompanyAuth-eyebrowSm-Z5jib {
  display: inline-block;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--red);
  margin-bottom: 10px;
}

.CompanyAuth-h1-hP0gK {
  font-size: clamp(30px, 5vw, 48px);
  line-height: 1.06;
  font-weight: 800;
  margin: 0 auto 16px;
  max-width: 780px;
}

.CompanyAuth-hl-cFFGN { color: var(--red); }

.CompanyAuth-sub-mlvXx {
  font-size: clamp(15px, 2.2vw, 18px);
  color: var(--muted);
  max-width: 640px;
  margin: 0 auto 28px;
  line-height: 1.55;
}

.CompanyAuth-ctaRow-EHldP {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 14px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

/* TRUST SIGNALS */

.CompanyAuth-trustRow-p7ui4 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 10px 22px;
  margin-top: 24px;
}

.CompanyAuth-trustItem-uIWmH {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  color: var(--ink);
}

.CompanyAuth-trustItem-uIWmH svg {
  width: 18px;
  height: 18px;
  color: var(--green);
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
}

/* VALUE PROPS */

.CompanyAuth-valueWrap-doe4q {
  padding: 12px 0 72px;
  background: #fff;
}

.CompanyAuth-valueGrid-byDZ6 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.CompanyAuth-valueCard-M8gjh {
  border: 1px solid var(--line);
  border-radius: 18px;
  padding: 26px 24px;
  background: #fff;
  -webkit-box-shadow: 0 10px 30px rgba(15, 18, 20, 0.04);
          box-shadow: 0 10px 30px rgba(15, 18, 20, 0.04);
}

.CompanyAuth-valueIc-nUizL {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: #fff0ef;
  color: var(--red);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  margin-bottom: 16px;
}

.CompanyAuth-valueIc-nUizL svg { width: 28px; height: 28px; }

.CompanyAuth-valueTitle-HYKXL { margin: 0 0 8px; font-size: 18px; font-weight: 800; }

.CompanyAuth-valueBody-YdCbZ { margin: 0; font-size: 14.5px; color: var(--muted); line-height: 1.55; }

/* HOW IT WORKS */

.CompanyAuth-howWrap-LPAoc {
  padding: 8px 0 80px;
  background: #fff;
}

.CompanyAuth-howTitle-DnwRM {
  font-size: clamp(22px, 3vw, 30px);
  font-weight: 800;
  text-align: center;
  margin: 0 0 28px;
}

.CompanyAuth-howGrid-K5fhN {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.CompanyAuth-howCard-WlED_ {
  border: 1px solid var(--line);
  border-radius: 18px;
  padding: 26px 24px;
  background: var(--bg);
}

.CompanyAuth-howNo-oyR6l {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 999px;
  background: var(--red);
  color: #fff;
  font-weight: 800;
  font-size: 16px;
  margin-bottom: 14px;
}

.CompanyAuth-howCardTitle-kurt9 { margin: 0 0 8px; font-size: 18px; font-weight: 800; }

.CompanyAuth-howCardBody-LIxa3 { margin: 0; font-size: 14.5px; color: var(--muted); line-height: 1.55; }

.CompanyAuth-howCta-s8lTy {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  gap: 16px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  margin-top: 32px;
}

/* AUTH CARD */

.CompanyAuth-authSection-q2ytB {
  background: radial-gradient(circle at 50% 0%, #fff0ef, transparent 60%), #fff;
  padding: 56px 0 80px;
  min-height: 60vh;
}

.CompanyAuth-authCard-ObRD6 {
  max-width: 520px;
  margin: 0 auto;
  border: 1px solid var(--line);
  border-radius: 22px;
  padding: 34px 34px 28px;
  background: #fff;
  -webkit-box-shadow: 0 18px 50px rgba(15, 18, 20, 0.08);
          box-shadow: 0 18px 50px rgba(15, 18, 20, 0.08);
}

.CompanyAuth-authTitle-y0ju9 { font-size: 26px; font-weight: 800; margin: 0 0 8px; }

.CompanyAuth-authHint-HtOL6 { font-size: 15px; color: var(--muted); line-height: 1.55; margin: 0 0 20px; }

/* FORM (shared tokens) */

.CompanyAuth-formGrid-OyMsz {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 6px;
}

.CompanyAuth-field-e1WHg { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; }

.CompanyAuth-fieldFull-E60Q8 { grid-column: 1 / -1; display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; margin-bottom: 6px; }

.CompanyAuth-field-e1WHg > span,
.CompanyAuth-fieldFull-E60Q8 > span {
  font-size: 13px;
  font-weight: 700;
  color: var(--ink);
  margin-bottom: 6px;
}

.CompanyAuth-input-ow17M {
  width: 100%;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  padding: 12px 13px;
  border: 1px solid var(--line);
  border-radius: 10px;
  font-family: inherit;
  font-size: 15px;
  color: var(--ink);
  background: #fff;
  -webkit-transition: border-color 0.16s, -webkit-box-shadow 0.16s;
  transition: border-color 0.16s, -webkit-box-shadow 0.16s;
  transition: border-color 0.16s, box-shadow 0.16s;
  transition: border-color 0.16s, box-shadow 0.16s, -webkit-box-shadow 0.16s;
}

.CompanyAuth-input-ow17M:focus {
  outline: none;
  border-color: var(--red);
  -webkit-box-shadow: 0 0 0 3px #fde7e8;
          box-shadow: 0 0 0 3px #fde7e8;
}

/* ALERTS */

.CompanyAuth-alertErr-ZABqf {
  padding: 11px 14px;
  border-radius: 10px;
  background: #fde7e8;
  color: var(--red-d);
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 16px;
}

.CompanyAuth-alertOk-RFJk0 {
  padding: 11px 14px;
  border-radius: 10px;
  background: #e7f6ec;
  color: #137a37;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 16px;
}

/* ACTIONS */

.CompanyAuth-ctaRow-EHldP .CompanyAuth-btn-_hFti,
.CompanyAuth-ctaRow-EHldP .CompanyAuth-btnGhost-WbmAX { padding: 13px 26px; }

.CompanyAuth-authActions-c_Rv1 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 12px;
  margin-top: 18px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.CompanyAuth-btn-_hFti {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: none;
  background: var(--red);
  color: #fff;
  font-family: inherit;
  font-size: 15px;
  font-weight: 800;
  padding: 12px 22px;
  border-radius: 12px;
  cursor: pointer;
  -webkit-transition: background 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
  transition: background 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
  transition: background 0.16s, transform 0.16s, box-shadow 0.16s;
  transition: background 0.16s, transform 0.16s, box-shadow 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
}

.CompanyAuth-btn-_hFti:hover:not(:disabled) {
  background: var(--red-d);
  -webkit-transform: translateY(-1px);
      -ms-transform: translateY(-1px);
          transform: translateY(-1px);
  -webkit-box-shadow: 0 12px 26px rgba(232, 35, 43, 0.25);
          box-shadow: 0 12px 26px rgba(232, 35, 43, 0.25);
}

.CompanyAuth-btnGhost-WbmAX {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: #fff;
  border: 1px solid var(--line);
  color: var(--ink);
  font-family: inherit;
  font-size: 15px;
  font-weight: 800;
  padding: 12px 22px;
  border-radius: 12px;
  cursor: pointer;
  -webkit-transition: border-color 0.16s, color 0.16s;
  transition: border-color 0.16s, color 0.16s;
}

.CompanyAuth-btnGhost-WbmAX:hover:not(:disabled) { border-color: var(--red); color: var(--red); }

.CompanyAuth-btnText-hM0kO {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: none;
  color: var(--muted);
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  text-decoration: underline;
  padding: 8px;
}

.CompanyAuth-btn-_hFti:disabled,
.CompanyAuth-btnGhost-WbmAX:disabled,
.CompanyAuth-btnText-hM0kO:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* SWITCH ROW */

.CompanyAuth-switchRow-LnaZ1 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 12px;
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px solid var(--line);
  font-size: 14px;
  color: var(--muted);
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.CompanyAuth-linkBtn-DXvhb {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: none;
  color: var(--red);
  font-family: inherit;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
  padding: 0;
}

.CompanyAuth-linkBtn-DXvhb:hover { text-decoration: underline; }

@media (max-width: 860px) {
  .CompanyAuth-valueGrid-byDZ6 { grid-template-columns: 1fr; }
  .CompanyAuth-howGrid-K5fhN { grid-template-columns: 1fr; }
}

@media (max-width: 620px) {
  .CompanyAuth-formGrid-OyMsz { grid-template-columns: 1fr; }
  .CompanyAuth-authCard-ObRD6 { padding: 26px 20px 22px; }
}
`, "",{"version":3,"sources":["webpack://./src/routes/become-a-company/CompanyAuth.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,SAAS;;AACT;EACE;qEACmE;EACnE,oBAAoB;EACpB,kBAAkB;AACpB;;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AACA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AACA,wBAAM,iBAAiB,EAAE;;AACzB;EACE,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAe;MAAf,eAAe;AACjB;;AAEA,kBAAkB;;AAClB;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAe;MAAf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAc;MAAd,kBAAc;UAAd,cAAc;AAChB;;AAEA,gBAAgB;;AAChB;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sDAA8C;UAA9C,8CAA8C;AAChD;;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAmB;AACrB;;AACA,iCAAe,WAAW,EAAE,YAAY,EAAE;;AAC1C,gCAAc,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAClE,+BAAa,SAAS,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;;AAEnF,iBAAiB;;AACjB;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AACA,kCAAgB,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AACpE,iCAAe,SAAS,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;;AACrF;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,SAAS;EACT,mBAAe;MAAf,eAAe;EACf,gBAAgB;AAClB;;AAEA,cAAc;;AACd;EACE,6EAA6E;EAC7E,oBAAoB;EACpB,gBAAgB;AAClB;;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,sDAA8C;UAA9C,8CAA8C;AAChD;;AACA,+BAAa,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AACjE,8BAAY,eAAe,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;;AAEvF,yBAAyB;;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AACA,2BAAS,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,4BAAsB,EAAtB,6BAAsB,EAAtB,0BAAsB,EAAtB,sBAAsB,EAAE;;AAChD,+BAAa,mBAAmB,EAAE,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,4BAAsB,EAAtB,6BAAsB,EAAtB,0BAAsB,EAAtB,sBAAsB,EAAE,kBAAkB,EAAE;;AAC7F;;EAEE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AACA;EACE,WAAW;EACX,8BAAsB;UAAtB,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gEAAgD;EAAhD,wDAAgD;EAAhD,gDAAgD;EAAhD,0EAAgD;AAClD;;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,qCAA6B;UAA7B,6BAA6B;AAC/B;;AAEA,WAAW;;AACX;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,YAAY;;AACZ;wDACoB,kBAAkB,EAAE;;AACxC;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAe;MAAf,eAAe;AACjB;;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,uFAA+D;EAA/D,+EAA+D;EAA/D,+DAA+D;EAA/D,kHAA+D;AACjE;;AACA;EACE,wBAAwB;EACxB,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;EAC3B,uDAA+C;UAA/C,+CAA+C;AACjD;;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mDAA2C;EAA3C,2CAA2C;AAC7C;;AACA,mDAAiC,wBAAwB,EAAE,iBAAiB,EAAE;;AAC9E;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,YAAY;AACd;;AACA;;;EAGE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,eAAe;;AACf;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,mBAAmB;EACnB,mBAAe;MAAf,eAAe;AACjB;;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AACA,mCAAiB,0BAA0B,EAAE;;AAE7C;EACE,+BAAa,0BAA0B,EAAE;EACzC,6BAAW,0BAA0B,EAAE;AACzC;;AACA;EACE,8BAAY,0BAA0B,EAAE;EACxC,8BAAY,uBAAuB,EAAE;AACvC","sourcesContent":[".page {\n  --red: #e8232b;\n  --red-d: #c2151c;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  --bg: #f7f8f9;\n  --green: #16a34a;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n  background: #fff;\n}\n\n.wrap,\n.authWrap {\n  max-width: 1080px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n/* HERO */\n.hero {\n  background: radial-gradient(circle at 85% 12%, #fff0ef, transparent 45%),\n    radial-gradient(circle at 8% 95%, #fff0ef, transparent 45%), #fff;\n  padding: 64px 0 44px;\n  text-align: center;\n}\n.eyebrow {\n  display: inline-block;\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--red);\n  margin-bottom: 14px;\n}\n.eyebrowSm {\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--red);\n  margin-bottom: 10px;\n}\n.h1 {\n  font-size: clamp(30px, 5vw, 48px);\n  line-height: 1.06;\n  font-weight: 800;\n  margin: 0 auto 16px;\n  max-width: 780px;\n}\n.hl { color: var(--red); }\n.sub {\n  font-size: clamp(15px, 2.2vw, 18px);\n  color: var(--muted);\n  max-width: 640px;\n  margin: 0 auto 28px;\n  line-height: 1.55;\n}\n.ctaRow {\n  display: flex;\n  gap: 14px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n/* TRUST SIGNALS */\n.trustRow {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 10px 22px;\n  margin-top: 24px;\n}\n.trustItem {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--ink);\n}\n.trustItem svg {\n  width: 18px;\n  height: 18px;\n  color: var(--green);\n  flex: 0 0 auto;\n}\n\n/* VALUE PROPS */\n.valueWrap {\n  padding: 12px 0 72px;\n  background: #fff;\n}\n.valueGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n}\n.valueCard {\n  border: 1px solid var(--line);\n  border-radius: 18px;\n  padding: 26px 24px;\n  background: #fff;\n  box-shadow: 0 10px 30px rgba(15, 18, 20, 0.04);\n}\n.valueIc {\n  width: 52px;\n  height: 52px;\n  border-radius: 14px;\n  background: #fff0ef;\n  color: var(--red);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n.valueIc svg { width: 28px; height: 28px; }\n.valueTitle { margin: 0 0 8px; font-size: 18px; font-weight: 800; }\n.valueBody { margin: 0; font-size: 14.5px; color: var(--muted); line-height: 1.55; }\n\n/* HOW IT WORKS */\n.howWrap {\n  padding: 8px 0 80px;\n  background: #fff;\n}\n.howTitle {\n  font-size: clamp(22px, 3vw, 30px);\n  font-weight: 800;\n  text-align: center;\n  margin: 0 0 28px;\n}\n.howGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n}\n.howCard {\n  border: 1px solid var(--line);\n  border-radius: 18px;\n  padding: 26px 24px;\n  background: var(--bg);\n}\n.howNo {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 999px;\n  background: var(--red);\n  color: #fff;\n  font-weight: 800;\n  font-size: 16px;\n  margin-bottom: 14px;\n}\n.howCardTitle { margin: 0 0 8px; font-size: 18px; font-weight: 800; }\n.howCardBody { margin: 0; font-size: 14.5px; color: var(--muted); line-height: 1.55; }\n.howCta {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-top: 32px;\n}\n\n/* AUTH CARD */\n.authSection {\n  background: radial-gradient(circle at 50% 0%, #fff0ef, transparent 60%), #fff;\n  padding: 56px 0 80px;\n  min-height: 60vh;\n}\n.authCard {\n  max-width: 520px;\n  margin: 0 auto;\n  border: 1px solid var(--line);\n  border-radius: 22px;\n  padding: 34px 34px 28px;\n  background: #fff;\n  box-shadow: 0 18px 50px rgba(15, 18, 20, 0.08);\n}\n.authTitle { font-size: 26px; font-weight: 800; margin: 0 0 8px; }\n.authHint { font-size: 15px; color: var(--muted); line-height: 1.55; margin: 0 0 20px; }\n\n/* FORM (shared tokens) */\n.formGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 6px;\n}\n.field { display: flex; flex-direction: column; }\n.fieldFull { grid-column: 1 / -1; display: flex; flex-direction: column; margin-bottom: 6px; }\n.field > span,\n.fieldFull > span {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--ink);\n  margin-bottom: 6px;\n}\n.input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 12px 13px;\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  font-family: inherit;\n  font-size: 15px;\n  color: var(--ink);\n  background: #fff;\n  transition: border-color 0.16s, box-shadow 0.16s;\n}\n.input:focus {\n  outline: none;\n  border-color: var(--red);\n  box-shadow: 0 0 0 3px #fde7e8;\n}\n\n/* ALERTS */\n.alertErr {\n  padding: 11px 14px;\n  border-radius: 10px;\n  background: #fde7e8;\n  color: var(--red-d);\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 16px;\n}\n.alertOk {\n  padding: 11px 14px;\n  border-radius: 10px;\n  background: #e7f6ec;\n  color: #137a37;\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 16px;\n}\n\n/* ACTIONS */\n.ctaRow .btn,\n.ctaRow .btnGhost { padding: 13px 26px; }\n.authActions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 18px;\n  flex-wrap: wrap;\n}\n.btn {\n  appearance: none;\n  border: none;\n  background: var(--red);\n  color: #fff;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 800;\n  padding: 12px 22px;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: background 0.16s, transform 0.16s, box-shadow 0.16s;\n}\n.btn:hover:not(:disabled) {\n  background: var(--red-d);\n  transform: translateY(-1px);\n  box-shadow: 0 12px 26px rgba(232, 35, 43, 0.25);\n}\n.btnGhost {\n  appearance: none;\n  background: #fff;\n  border: 1px solid var(--line);\n  color: var(--ink);\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 800;\n  padding: 12px 22px;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: border-color 0.16s, color 0.16s;\n}\n.btnGhost:hover:not(:disabled) { border-color: var(--red); color: var(--red); }\n.btnText {\n  appearance: none;\n  background: transparent;\n  border: none;\n  color: var(--muted);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  text-decoration: underline;\n  padding: 8px;\n}\n.btn:disabled,\n.btnGhost:disabled,\n.btnText:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* SWITCH ROW */\n.switchRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 22px;\n  padding-top: 18px;\n  border-top: 1px solid var(--line);\n  font-size: 14px;\n  color: var(--muted);\n  flex-wrap: wrap;\n}\n.linkBtn {\n  appearance: none;\n  background: transparent;\n  border: none;\n  color: var(--red);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 800;\n  cursor: pointer;\n  padding: 0;\n}\n.linkBtn:hover { text-decoration: underline; }\n\n@media (max-width: 860px) {\n  .valueGrid { grid-template-columns: 1fr; }\n  .howGrid { grid-template-columns: 1fr; }\n}\n@media (max-width: 620px) {\n  .formGrid { grid-template-columns: 1fr; }\n  .authCard { padding: 26px 20px 22px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `CompanyAuth-page-GUyaI`,
	"wrap": `CompanyAuth-wrap-UateC`,
	"authWrap": `CompanyAuth-authWrap-VeVZx`,
	"hero": `CompanyAuth-hero-PChKe`,
	"eyebrow": `CompanyAuth-eyebrow-O7b7Q`,
	"eyebrowSm": `CompanyAuth-eyebrowSm-Z5jib`,
	"h1": `CompanyAuth-h1-hP0gK`,
	"hl": `CompanyAuth-hl-cFFGN`,
	"sub": `CompanyAuth-sub-mlvXx`,
	"ctaRow": `CompanyAuth-ctaRow-EHldP`,
	"trustRow": `CompanyAuth-trustRow-p7ui4`,
	"trustItem": `CompanyAuth-trustItem-uIWmH`,
	"valueWrap": `CompanyAuth-valueWrap-doe4q`,
	"valueGrid": `CompanyAuth-valueGrid-byDZ6`,
	"valueCard": `CompanyAuth-valueCard-M8gjh`,
	"valueIc": `CompanyAuth-valueIc-nUizL`,
	"valueTitle": `CompanyAuth-valueTitle-HYKXL`,
	"valueBody": `CompanyAuth-valueBody-YdCbZ`,
	"howWrap": `CompanyAuth-howWrap-LPAoc`,
	"howTitle": `CompanyAuth-howTitle-DnwRM`,
	"howGrid": `CompanyAuth-howGrid-K5fhN`,
	"howCard": `CompanyAuth-howCard-WlED_`,
	"howNo": `CompanyAuth-howNo-oyR6l`,
	"howCardTitle": `CompanyAuth-howCardTitle-kurt9`,
	"howCardBody": `CompanyAuth-howCardBody-LIxa3`,
	"howCta": `CompanyAuth-howCta-s8lTy`,
	"authSection": `CompanyAuth-authSection-q2ytB`,
	"authCard": `CompanyAuth-authCard-ObRD6`,
	"authTitle": `CompanyAuth-authTitle-y0ju9`,
	"authHint": `CompanyAuth-authHint-HtOL6`,
	"formGrid": `CompanyAuth-formGrid-OyMsz`,
	"field": `CompanyAuth-field-e1WHg`,
	"fieldFull": `CompanyAuth-fieldFull-E60Q8`,
	"input": `CompanyAuth-input-ow17M`,
	"alertErr": `CompanyAuth-alertErr-ZABqf`,
	"alertOk": `CompanyAuth-alertOk-RFJk0`,
	"btn": `CompanyAuth-btn-_hFti`,
	"btnGhost": `CompanyAuth-btnGhost-WbmAX`,
	"authActions": `CompanyAuth-authActions-c_Rv1`,
	"btnText": `CompanyAuth-btnText-hM0kO`,
	"switchRow": `CompanyAuth-switchRow-LnaZ1`,
	"linkBtn": `CompanyAuth-linkBtn-DXvhb`
};
module.exports = ___CSS_LOADER_EXPORT___;
